module.exports = __webpack_public_path__ + "static/media/dot.493acdfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/dot.svg
// module id = ./src/assets/media/forum/dot.svg
// module chunks = 16